export const DISCLAIMER_TEXTS = {
  CLOSED: {
    PARAGRAPH: `השימוש בRentAI הנו במטרה לספק מידע כללי בלבד, והמידע המועבר באמצעות הצ'אט אינו מהווה ייעוץ משפטי, פיננסי או כל ייעוץ אחר.`,
    READ_MORE: `קראו עוד`,
  },
  OPEN: `השימוש בRentAI הנו ניסיוני והמידע המועבר באמצעותו מבוסס על מאגרי מידע ומידע ציבורי זמין, ועל כן עלול להיות לא מעודכן או לא מדויק בכל עת בו נעשה בו שימוש.\nיש לקחת בחשבון את האפשרות לתקלות טכניות ו/או בעיות בהבנת ניסוח השאלות המופנות לצ'אט אשר עלולות להוביל למידע שגוי או לא מדויק. החברה אינה נושאת באחריות למידע המועבר ולא תשא באחריות לכל פעולה או החלטה שתתקבל בעקבות השימוש בצ'אט.`,
};
